/* eslint-disable jsx-a11y/heading-has-content */
export const ActivityLoadingSkeleton = () => (
  <div className="Definition_of_terms mb_24">
    <div className="book_main_img">
      <h4 className="content-skeleton m-0"></h4>
    </div>
    <div className="text_right">
      <div className="book_name">
        <h6 className="content-skeleton m-0"></h6>
        <h5 className="content-skeleton m-0"></h5>
        <div className="book_title_container w-100">
          <h4 className="content-skeleton m-0"></h4>
        </div>
      </div>
      <div className="d-flex flex-column gap-2 book_card_actions">
        <h6 className="content-skeleton m-0"></h6>
        <h5 className="content-skeleton m-0"></h5>
        <h5 className="content-skeleton m-0"></h5>
      </div>
    </div>
  </div>
);